module.exports = __webpack_public_path__ + "static/image-revenue-02e2436792c3ebbb07dedd894e063799.svg";